import './App.css';
import Landingpage from "./Components/LandingPage/LandingPage";
import "bootstrap/dist/css/bootstrap.min.css";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Login from './Components/userauth/login';
import Registration from './Components/userauth/signup';
import Main from './Components/TeacherModule/Layouts/Main';
import Home from './Components/TeacherModule/Home/Home';
import CourseSummary from "./Components/TeacherModule/Course/CourseSummary";
import CourseCreation from './Components/TeacherModule/Course/CouseCreation';
import CourseContent from "./Components/TeacherModule/Course/CourseContent";
import { UserProvider } from './Components/UserContext';
import MyCourses from './Components/TeacherModule/Course/MyCourses';
import StudentMain from '../src/Components/Student/Layouts/Main';
import Profile from './Components/Student/Profile/Profile';
import AllCourses from './Components/Student/Course/AllCourse';
import KnowledgeTest from './Components/Student/Course/KnowledgeTest';
import Publish from './Components/TeacherModule/Course/Publish';
import QuizEditor from './Components/TeacherModule/Course/kt';
import CourseOutline from './Components/Student/Course/CourseOutline';
import Course from './Components/Student/Course/CourseContent';
import Help from './Components/Help';
import Feedback from './Components/Student/Feedback';
import Tobegenerated from './Components/Tobegenerated';
import Analytics from './Components/TeacherModule/Analytics/Analytics';

function App() {
  return (
		<div className="main">
			<UserProvider>
				<Router>
					<Routes className="dd">
						<Route path="" element={<Landingpage />} />
						<Route path="/login" element={<Login />} />
						<Route path="/signup" element={<Registration />} />
						<Route
							path="/teacher/home"
							element={
								<Main>
									<Home />
								</Main>
							}></Route>

						<Route
							path="/teacher/courses"
							element={
								<Main>
									<CourseCreation />
								</Main>
							}></Route>

						<Route
							path="/teacher/mycourses"
							element={
								<Main>
									<MyCourses />
								</Main>
							}></Route>

						<Route
							path="/teacher/courses/content/:courseId/module?/:moduleIndex?/submodule?/:SubmoduleIndex?/quiz?"
							element={
								<>
									<CourseContent />
								</>
							}></Route>

						<Route
							path="/teacher/courses/create/course/:course/:target/:duration"
							element={
								<Main>
									<CourseSummary />
								</Main>
							}
						/>
						<Route
							path="/teacher/analytics"
							element={
								<Main>
									<Analytics />
								</Main>
							}
						/>
						<Route
							path="/teacher/help"
							element={
								<Main>
									<Help />
								</Main>
							}
						/>
						<Route
							path="/teacher/courses/:course/save"
							element={
								<>
									<Publish />
								</>
							}
						/>
						<Route
							path="/teacher/courses/:course/kt"
							element={
								<>
									<QuizEditor />
								</>
							}
						/>

						<Route
							path="/student/home"
							element={
								<StudentMain>
									<Home />
								</StudentMain>
							}></Route>
						<Route
							path="/student/profile"
							element={
								<StudentMain>
									<Profile />
								</StudentMain>
							}></Route>
						<Route
							path="/student/courses"
							element={
								<StudentMain>
									<AllCourses />
								</StudentMain>
							}></Route>
						<Route
							path="/student/knowledgeTest/:courseId"
							element={
								<>
									<KnowledgeTest />
								</>
							}></Route>
						<Route
							path="/student/courses/outline/:courseId"
							element={
								<StudentMain>
									<CourseOutline />
								</StudentMain>
							}></Route>
						<Route
							path="/student/help"
							element={
								<StudentMain>
									<Help />
								</StudentMain>
							}></Route>
						<Route
							path="/student/feedback"
							element={
								<StudentMain>
									<Feedback />
								</StudentMain>
							}></Route>
						<Route
							path="/student/courses/outline/:courseId"
							element={
								<StudentMain>
									<CourseOutline />
								</StudentMain>
							}></Route>
						<Route
							path="/student/courses/:courseId/module?/:moduleId?/submodule?/:submoduleId?"
							element={
								<>
									<Course />
								</>
							}></Route>
					</Routes>
				</Router>
			</UserProvider>
		</div>
	);
}

export default App;
